import { Link } from "react-router-dom";
import { X, Calendar } from "lucide-react";
import type { ActivityTask } from "../../store/useActivityTaskStore";
import { meetingClient, meetingDateLabel, isToday } from "../../lib/meetings";

export function MeetingsModal({
  meetings,
  onClose,
}: {
  meetings: ActivityTask[];
  onClose: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="bg-surface-container-lowest w-full max-w-xl max-h-[90vh] flex flex-col rounded-2xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-outline-variant">
          <div>
            <h2 className="text-lg font-bold text-on-surface">Scheduled Meetings</h2>
            <p className="text-[11px] text-on-surface-variant">
              {meetings.length} upcoming · {meetings.filter((m) => isToday(m.dueDate)).length} today
            </p>
          </div>
          <button onClick={onClose} className="p-1.5 text-outline hover:bg-surface-container rounded-full">
            <X size={18} />
          </button>
        </div>

        <div className="cre-scroll overflow-y-auto px-5 py-4 space-y-2.5 flex-1">
          {meetings.length === 0 ? (
            <div className="text-center py-12 text-outline">
              No upcoming meetings. Create an activity with the “Meeting” category to schedule one.
            </div>
          ) : (
            meetings.map((m) => (
              <div
                key={m._id}
                className="p-3 bg-surface-bright border border-outline-variant rounded-lg flex items-center justify-between gap-3"
              >
                <div className="min-w-0">
                  <div className="flex items-center gap-1.5 mb-0.5">
                    <Calendar size={15} className="text-primary shrink-0" />
                    <span className="text-sm font-semibold text-on-surface truncate">
                      {m.title || m.description || "Meeting"}
                    </span>
                  </div>
                  {meetingClient(m) && (
                    <div className="text-[13px] text-on-surface-variant truncate">
                      Client: <span className="font-medium">{meetingClient(m)}</span>
                    </div>
                  )}
                </div>
                <div className="flex flex-col items-end gap-1 shrink-0">
                  <span
                    className={`text-xs font-bold ${
                      isToday(m.dueDate) ? "text-primary" : "text-on-surface-variant"
                    }`}
                  >
                    {meetingDateLabel(m.dueDate)}
                  </span>
                  <Link to="/activities" className="text-[11px] text-primary hover:underline">
                    Open →
                  </Link>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
